"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _HiButton = _interopRequireDefault(require("../HiButton"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _helpers = require("../utils/helpers");
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      maxHeight: 40,
      marginRight: 12,
      padding: 4,
      backgroundColor: theme.palette.background2,
      borderRadius: '2px 2px 0 0',
      width: '100%',
      maxWidth: 200,
      minWidth: 120,
      borderBottom: "solid 1px ".concat(theme.palette.input.bottomLine)
    },
    button: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: theme.palette.background2,
      color: theme.palette.text.disabled,
      textTransform: 'inherit',
      width: '50%',
      fontSize: 15,
      fontWeight: 400
    },
    buttonLeft: {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0
    },
    buttonRight: {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0
    },
    checked: {
      boxShadow: theme.shadows[2]
    },
    checkedPrimary: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
      }
    },
    checkedSecondary: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText
      }
    },
    checkedPositive: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.contrastText
      }
    },
    checkedNegative: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
      }
    },
    checkedMiddle: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText
      }
    },
    checkedNeutral: {
      '&:not($disabled)': {
        backgroundColor: theme.palette.neutral.main,
        color: theme.palette.neutral.contrastText
      }
    },
    disabled: {
      '&$checked': {
        backgroundColor: theme.palette.mode === 'light' ? '#bdbdbd' : '#424242',
        color: theme.palette.mode === 'light' ? '#fafafa' : '#bdbdbd'
      },
      boxShadow: 'none'
    }
  };
};

/**
 * Ce composant affiche un switch entre 2 valeurs associées à deux labels.
 * par défaut ON/OFF associé à true/false.
 */
function HiSwitchState(props) {
  var classes = props.classes,
    className = props.className,
    checked = props.checked,
    color = props.color,
    leftLabel = props.leftLabel,
    rightLabel = props.rightLabel,
    leftValue = props.leftValue,
    rightValue = props.rightValue,
    disabled = props.disabled,
    onChange = props.onChange;
  var isHiColor = ['primary', 'secondary', 'success', 'error', 'warning', 'neutral'].includes(color);
  var buttonLeftClass = (0, _classnames.default)(classes.button, classes.buttonLeft, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.checked, checked === leftValue), classes.checkedNeutral, !disabled && checked === leftValue && !isHiColor), classes["checked".concat((0, _helpers.capitalize)(color))], !disabled && checked === leftValue && isHiColor), classes.disabled, disabled));
  var buttonRightClass = (0, _classnames.default)(classes.button, classes.buttonRight, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.checked, checked === rightValue), classes.checkedNeutral, !disabled && checked === rightValue && !isHiColor), classes["checked".concat((0, _helpers.capitalize)(color))], !disabled && checked === rightValue && isHiColor), classes.disabled, disabled));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    size: "small",
    className: buttonLeftClass,
    value: leftValue,
    onClick: function onClick(event) {
      return onChange(event, leftValue);
    },
    disabled: disabled
  }, leftLabel), /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    size: "small",
    className: buttonRightClass,
    value: rightValue,
    onClick: function onClick(event) {
      return onChange(event, rightValue);
    },
    disabled: disabled
  }, rightLabel));
}
HiSwitchState.defaultProps = {
  checked: 'on',
  color: 'inherit',
  leftLabel: 'Off',
  rightLabel: 'On',
  leftValue: 'off',
  rightValue: 'on',
  disabled: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSwitchState'
})(HiSwitchState);